import get from 'lodash/get';
import forEach from 'lodash/forEach';

function validateTransferScene(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  if (!caseConf._endLocation) {
    // Transfer Actions
    const transferActionNodes = nodeInfo.actionNodes.filter(node => get(node, 'data.action.type') === 'TRANSFER');
    transferActionNodes.forEach((node) => {
      warnings.push(scenarioWarning());
      warnings.push(caseLogicWarning(node.id));
    });

    // Transfer Checks
    nodeInfo.checkNodes.forEach((node) => {
      forEach(node.data, (check, checkKey) => {
        if (check.type === 'TRANSFER') {
          warnings.push(scenarioWarning());
          warnings.push(caseLogicWarning(node.id, checkKey));
        }
      });
    });
  }

  return {
    errors,
    warnings,
  };
}

function caseLogicWarning(nodeId, checkKey) {
  return {
    message: 'Transfer action found, but Case has no ending scene to transfer into.',
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      checkKey,
      scope: 'control',
      defaultVisibility: false,
    },
  };
}

function scenarioWarning() {
  return {
    message: 'Transfer action found in Case Logic, but Case has no ending scene to transfer into.',
    category: 'scenario',
    field: '_endLocation',
    id: null,
    metadata: {
      defaultVisibility: false,
    },
  };
}

export default validateTransferScene;
